import { Box, Typography } from "@mui/material";
import { tokens } from "../../../theme";
import MemoryBookCard, { MemoryBookEntry } from "./MemoryBookCard";

type MemoryBookStatus = "overdue" | "in_danger" | "safe";

const STATUS_CONFIG: Record<
  MemoryBookStatus,
  { label: string; borderColor: string }
> = {
  overdue:   { label: "OVER DUE",  borderColor: "#E11D48" },
  in_danger: { label: "IN DANGER", borderColor: "#f59e0b" },
  safe:      { label: "SAFE",      borderColor: "#10b981" },
};

interface StatusColumnProps {
  status: MemoryBookStatus;
  entries: MemoryBookEntry[];
  colors: ReturnType<typeof tokens>;
  onCardClick: (entry: MemoryBookEntry) => void;
}

const StatusColumn = ({ status, entries, colors, onCardClick }: StatusColumnProps) => {
  const cfg = STATUS_CONFIG[status];

  return (
    <Box
      sx={{
        minWidth: { xs: 240, sm: 260 },
        maxWidth: { xs: 240, sm: 260 },
        borderTop:    `1.5px solid ${cfg.borderColor}`,
        borderLeft:   `1.5px solid ${cfg.borderColor}`,
        borderRight:  `1.5px solid ${cfg.borderColor}`,
        borderBottom: `4px solid ${cfg.borderColor}`,
        borderRadius: "30px",
        p: 2,
        backgroundColor: colors.primary[800],
        flexShrink: 0,
      }}
    >
      {/* Column header */}
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.08em",
          color: cfg.borderColor,
          mb: 1.5,
        }}
      >
        {cfg.label}
      </Typography>

      {/* Cards */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {entries.map((entry) => (
          <MemoryBookCard
            key={entry.id}
            entry={entry}
            colors={colors}
            onClick={() => onCardClick(entry)}
          />
        ))}
        {entries.length === 0 && (
          <Typography
            sx={{
              fontSize: "0.8rem",
              color: colors.primary[700],
              textAlign: "center",
              py: 2,
            }}
          >
            No entries
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StatusColumn;